import React from 'react';
import PropTypes from 'prop-types';
import { CallupHead } from 'ThreeTerminal_mobile';
import errorBoundary from '@ifeng/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
        };

        const headData = {
            isVideoShare: false,
            pageInfo: {
                type: 'web',
                url: typeof window === 'object' ? location.href : '',
                id: 'https://ishare.ifeng.com/c/s/80kdzDaUKoa',
                downloads,
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: `ucms_${content.base62Id}`,
                kind: 'topic3',
                callupKind: 'inter|inter_dsjzt03',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: `ucms_${content.base62Id}`,
                kind: 'topic3',
                callupKind: 'inter|inter_dsjzt03',
            },
            hotKeyword: ['更多精彩内容，尽在凤凰新闻客户端'],
        };

        return <CallupHead content={headData} />;
    }
}

export default errorBoundary(Header);
